import React from "react";
import "./creatAccount.scss";
import PageTemplate from "components/pageTemplate/PageTemplate";

const CreateAccount = () => {
  return (
    <div className="CreatAccount">
      <PageTemplate>
        <h1>Hellooooo Creat Account</h1>
      </PageTemplate>
    </div>
  );
};
export default CreateAccount;
